import { ISelectOption } from '@/components/form/fields/SelectField';

export const tagOption: ISelectOption[] = [
  { value: 'POSITIVE', label: 'Positive' },
  { value: 'NEGATIVE', label: 'Negative' },
];
